import * as React from "react";
import { Loader2 } from "lucide-react";
import { cn } from "lib/utils";

type LoaderProps = {
  className?: string;
  size?: number;           // px
  label?: string;          // optional accessible label
};

export const Loader: React.FC<LoaderProps> = ({ className, size = 20, label = "Loading" }) => {
  return (
    <span role="status" aria-live="polite" className="inline-flex items-center gap-2">
      <Loader2
        aria-hidden="true"
        size={size}
        className={cn(
          // spin + inherit current text color so it matches any theme/variant
          "animate-spin text-current",
          className
        )}
      />
      <span className="sr-only">{label}</span>
    </span>
  );
};

/** full-screen-ish dim overlay with centered loader (use inside relatively positioned parent) */
export const LoaderOverlay: React.FC<{ label?: string }> = ({ label }) => (
  <div className="absolute inset-0 z-20 grid place-items-center bg-black/10 backdrop-blur-[1px] dark:bg-black/20">
    <div className="rounded-md /90 px-3 py-2 text-sm text-gray-700 shadow-sm dark:bg-dark-700/90 dark:text-gray-200">
      <Loader className="mr-2" /> {label ?? "Loading..."}
    </div>
  </div>
);
